// Date range filter component for filtering data by date range

import { HStack, Input, FormControl, FormLabel, Button } from '@chakra-ui/react';

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onDateRangeChange: (startDate: string, endDate: string) => void;
  onReset?: () => void;
}

/**
 * Date range filter component
 * Allows users to select a start and end date for filtering data
 * Triggers API call immediately when dates are changed
 */
export function DateRangeFilter({
  startDate,
  endDate,
  onDateRangeChange,
  onReset,
}: DateRangeFilterProps) {
  const handleStartDateChange = (newStartDate: string) => {
    onDateRangeChange(newStartDate, endDate);
  };

  const handleEndDateChange = (newEndDate: string) => {
    onDateRangeChange(startDate, newEndDate);
  };

  return (
    <HStack spacing={4} flexWrap="wrap">
      <FormControl maxW="200px">
        <FormLabel fontSize="sm" color="text-secondary" mb={1}>
          Start Date
        </FormLabel>
        <Input
          type="date"
          value={startDate}
          onChange={(e) => handleStartDateChange(e.target.value)}
          max={endDate}
          bg="bg-surface"
          borderColor="border-default"
          _hover={{ borderColor: 'border-hover' }}
          _focus={{
            borderColor: 'brand.500',
            boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)',
          }}
        />
      </FormControl>

      <FormControl maxW="200px">
        <FormLabel fontSize="sm" color="text-secondary" mb={1}>
          End Date
        </FormLabel>
        <Input
          type="date"
          value={endDate}
          onChange={(e) => handleEndDateChange(e.target.value)}
          min={startDate}
          bg="bg-surface"
          borderColor="border-default"
          _hover={{ borderColor: 'border-hover' }}
          _focus={{
            borderColor: 'brand.500',
            boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)',
          }}
        />
      </FormControl>

      {onReset && (
        <Button
          size="sm"
          variant="outline"
          alignSelf="flex-end"
          onClick={onReset}
        >
          Reset
        </Button>
      )}
    </HStack>
  );
}
